<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title"><span class="bold">PHOENIX  13</span></h1>
<p class="titlesub"><span class="bold">Americal Division Artillery Air</span></p>
<p class="titlesub1"><span class="bold">Section Helicopters in Vietnam</span></p>
<p class="author">DARRYL JAMES</p>
<div class="img_container_j">
<img alt="images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?143031d2